import { ContentSections, useContentBlocks } from '../components/content/ContentSections';
import { StaticPageLayout } from '../components/layout/StaticPageLayout';

const TERMS_UPDATED = '2026-10-20';

export function TermsPage() {
  const blocks = useContentBlocks('staticPages.terms.blocks');

  return (
    <StaticPageLayout
      titleKey="staticPages.terms.title"
      subtitleKey="staticPages.terms.subtitle"
      lastUpdatedKey="staticPages.terms.lastUpdated"
      date={TERMS_UPDATED}
    >
      <ContentSections blocks={blocks} />
    </StaticPageLayout>
  );
}
